<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text">Привилегии </span>
        <v-icon
          @mouseover="openInfo($event)"
          @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)"
          >mdi-information</v-icon
        >
      </div>
      <div>
        <v-btn
          depressed
          outlined
          color="var(--app-dark-blue-1)"
          class="button-accept"
          style="width: 229px !important"
          @click="goToAddPrivileges"
        >
          <span> + Добавить привилегию </span>
        </v-btn>
      </div>
    </div>
    <v-menu
      v-model="showInfo"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-card min-width="300px" min-height="100px">
        <div class="menu-container">
          <div class="menu-container-text">
            Подробная информация о привилегиях, отображается на первом экране
            раздела привилегии.
          </div>
          <div class="menu-container-text">
            Полное описание содержит в себе краткое и может быть дополнено.
          </div>
        </div>
      </v-card>
    </v-menu>

    <div v-if="loading" class="privileges-table">
      <PrivilegesList :tableHeaders="tableHeaders" :items="privilegesList" @goToEdit="goToPrivileges"></PrivilegesList>
    </div>
  </div>
</template>

<script>
import PrivilegesList from "./PrivilegesList";
export default {
  components: {
    PrivilegesList,
  },
  mounted(){
    this.getListPrivilegies()
  },
  data: () => ({
    loading: false,
    privilegesList: null,
    showInfo: false,
    dialog: false,
    x: null,
    y: null,
    tableHeaders: [
      {
        text: "",
        sortable: false,
        value: "",
        width: 75,
      },
      {
        text: "Порядок отображения",
        sortable: false,
        value: "",
        width: 75,
      },
      {
        text: "Название",
        sortable: false,
        value: "title",
      },
      {
        text: "Ссылка",
        sortable: false,
        value: "link",
      },
      {
        text: "Кол-во Акций",
        sortable: false,
        value: "sharesAmount",
      },
    ],
  }),
  methods: {
    goToPrivileges(item){
      this.$router.push({name:'DetailPrivilleges', params: {id: item.id}})
    },
    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    goToAddPrivileges() {
      this.$router.push({ name: "AddPrivilegies" });
    },
    getListPrivilegies() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + "/privileges", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        })
        .then((res) => {
          this.privilegesList = res.data;
          this.loading = true
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
};
</script>

<style lang="scss">
</style>
